<template lang="pug">
  .notification
    span
      b
        | Esperando Datos... 
        span.icon.has-text-primary
          i.fas.fa-pulse
</template>

<script>
  export default {
    name: 'NotificacionData'
    
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/NotificacionData.vue